import { Icons } from '@amo/core/components/containers';

const ErreurTarif = (props) => {
    const { text, previousQuestion } = props;

    return (
        <div>
            <div className={'bg-secondary-light p-4 mb-5 rounded text-center'}>
                <div className={'f-21 text-danger mb-3'}>
                    <Icons className={`d-inline-block position-relative me-2`} fontSize={30} icon={'triangle'} />
                    <p>Cher conseiller,</p>
                    <p>Les informations que vous avez saisies ne nous permettent pas de proposer un tarif en ligne.</p>
                    <p>Le tarif est en feu rouge.</p>
                    <br />
                    <b>Ces informations ne doivent pas être communiquées au client</b>
                    {text && <p>Motif du refus INTERNE : {text}</p>}
                    <p>A très bientôt</p>
                </div>
                {previousQuestion && (
                    <button
                        className={`btn btn-outline-primary medium-rounded order-lg-0`}
                        onClick={() => previousQuestion()}
                    >
                        Retour
                    </button>
                )}
            </div>
        </div>
    );
};

export default ErreurTarif;
